// Core component styles
const coreStyles={container:{},title:{}};/**
 * Combines coreStyles and contextStyles
 * @param {Object} contextStyles
 */const getStyles=function(){let contextStyles=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{container:{...coreStyles.container,...contextStyles.container,'& .MuiTypography-root':{...coreStyles.title,...contextStyles.title}}};};export default getStyles;